// =============================================================================
// NOTIFICATION BELL COMPONENT
// =============================================================================

import { useEffect } from 'react';
import { useNotificationStore } from '../../stores/notificationStore.js';
import { NotificationPanel } from './NotificationPanel.js';
import { socketService } from '../../api/socket.js';

// =============================================================================
// COMPONENT
// =============================================================================

export function NotificationBell() {
  const { unreadCount, isPanelOpen, togglePanel, loadUnreadCount, handleNewNotification, handleBadgeUpdate } =
    useNotificationStore();

  // Load initial unread count
  useEffect(() => {
    void loadUnreadCount();
  }, [loadUnreadCount]);

  // Setup socket listeners
  useEffect(() => {
    const unsubscribeNew = socketService.on('notification:new', (notification) => {
      handleNewNotification(notification);
    });

    const unsubscribeBadge = socketService.on('notification:badge-update', (data) => {
      handleBadgeUpdate(data.count);
    });

    return () => {
      unsubscribeNew();
      unsubscribeBadge();
    };
  }, [handleNewNotification, handleBadgeUpdate]);

  return (
    <div className="relative">
      <button
        className="relative p-2 text-ink-3 hover:text-ink-1 transition-colors"
        onClick={togglePanel}
        data-notification-bell
        data-testid="notification-bell"
        aria-label="Notifications"
      >
        {/* Bell icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          />
        </svg>

        {/* Badge */}
        {unreadCount > 0 && (
          <span
            className="absolute top-0.5 right-0.5 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-xs font-bold text-white bg-danger rounded-full"
            data-testid="notification-badge"
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {/* Panel */}
      {isPanelOpen && <NotificationPanel />}
    </div>
  );
}
